"use client";
import { NoSSR } from "@/utils/SSR";
import { GridObjectFactory } from "./grid/GridObjectFactory";
import { Grid, type IGridItem } from "./grid/Grid";
import { GridFactory as _GridFactory } from "./GridFactory";

const GridFactory = NoSSR(async () => (await import("./GridFactory")).GridFactory) as typeof _GridFactory;

export { GridFactory, GridObjectFactory, Grid, type IGridItem };
